import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enAvailable from "./locales/en/available.json";
import enExpired from "./locales/en/expired.json";
import enContact from "./locales/en/contact.json";
import enPrivacy from "./locales/en/privacy.json";
import enTerms from "./locales/en/terms.json";
import enBadge from "./locales/en/badge.json";

import esCommon from "./locales/es/common.json";
import esHome from "./locales/es/home.json";
import esAvailable from "./locales/es/available.json";
import esExpired from "./locales/es/expired.json";
import esContact from "./locales/es/contact.json";
import esPrivacy from "./locales/es/privacy.json";
import esTerms from "./locales/es/terms.json";
import esBadge from "./locales/es/badge.json";

import zhCNCommon from "./locales/zh-CN/common.json";
import zhCNHome from "./locales/zh-CN/home.json";
import zhCNAvailable from "./locales/zh-CN/available.json";
import zhCNExpired from "./locales/zh-CN/expired.json";
import zhCNContact from "./locales/zh-CN/contact.json";
import zhCNPrivacy from "./locales/zh-CN/privacy.json";
import zhCNTerms from "./locales/zh-CN/terms.json";
import zhCNBadge from "./locales/zh-CN/badge.json";

// Detect language from URL path — important for react-snap pre-rendering
const getInitialLanguage = (): string => {
  if (typeof window !== "undefined") {
    const p = window.location.pathname;
    if (p === "/es" || p.startsWith("/es/")) return "es";
    if (p === "/zh-CN" || p.startsWith("/zh-CN/")) return "zh-CN";
  }
  return "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      home: enHome,
      available: enAvailable,
      expired: enExpired,
      contact: enContact,
      privacy: enPrivacy,
      terms: enTerms,
      badge: enBadge,
    },
    es: {
      common: esCommon,
      home: esHome,
      available: esAvailable,
      expired: esExpired,
      contact: esContact,
      privacy: esPrivacy,
      terms: esTerms,
      badge: esBadge,
    },
    "zh-CN": {
      common: zhCNCommon,
      home: zhCNHome,
      available: zhCNAvailable,
      expired: zhCNExpired,
      contact: zhCNContact,
      privacy: zhCNPrivacy,
      terms: zhCNTerms,
      badge: zhCNBadge,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
